import React, { Component } from 'react';
import DatePicker from 'react-datepicker';
import moment from 'moment';
import 'react-datepicker/dist/react-datepicker.css';
import swal from 'sweetalert2';

class addEventBlock extends Component {
  constructor(props) {
    super(props);
    this.state={
      selectStartTime: moment('2018-09-08T10:00'),
      selectEndTime: moment('2018-09-08T10:00'),
      jobType: 0,
      jobTypeList: [
        {
          id: 1,
          title: '正常班',
        },{
          id: 2,
          title: '可支援',
        },
      ]
    }
    this.handleSelectStartTimeChange = this.handleSelectStartTimeChange.bind(this);
    this.handleSelectEndTimeChange = this.handleSelectEndTimeChange.bind(this);
    this.handleJobTypeChange = this.handleJobTypeChange.bind(this);
    this.handleSaveWorkTime = this.handleSaveWorkTime.bind(this);
  }

  handleSelectStartTimeChange(moment) {
    this.setState({
      selectStartTime: moment
    })
  }

  handleSelectEndTimeChange(moment) {
    this.setState({
      selectEndTime: moment
    })
  }

  handleJobTypeChange(e) {
    this.setState({
      jobType: e.target.value
    })
  }

  handleSaveWorkTime(e) {
    e.preventDefault();
    const { editDate, toggleOpen } = this.props;
    const { jobType, selectStartTime,  selectEndTime} = this.state;
    if (jobType === 0) {
      swal({
        type: 'error',
        title: '請選擇班別',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    } else if (selectEndTime.diff(selectStartTime) <= 0) {
      swal({
        type: 'error',
        title: '時間輸入有誤',
        showConfirmButton: false,
        showCloseButton: true,
        heightAuto: false,
        width: '250px'
      });
      return;
    }

    let data = {
      start: editDate + ' ' + selectStartTime.format('LT'),
      end: editDate + ' ' + selectEndTime.format('LT'),
      resourceId: jobType,
      title: ''
    }
    this.props.saveWorkTime(data);
    toggleOpen();
  }

  render() {
    let { isVisible, toggleOpen, editDate } = this.props;
    if (!isVisible) {
      return null;
    }
    return (
      <div className="u-editblock">
        <div className="form-block bounceIn" style={{minWidth: '320px'}}>
          <div className="u-small-title">我要上班</div>
          <form className="u-form">
            <div className="row">
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>日期： {editDate}</label>
              </div>
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>班別：</label>
                <select value={Number(this.state.jobType)} className="u-form__select" 
                  onChange={this.handleJobTypeChange}
                >
                  <option value="0" disabled>請選擇</option>
                  {
                    this.state.jobTypeList.map(jobType => (
                      <option key={jobType.id} value={jobType.id}>{ jobType.title }</option>
                    ))
                  }
                </select>
              </div>
            </div>
            <div className="row">
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>時段：</label>
                <DatePicker
                  id="addShift_date_picker_selectStartTime"
                  locale="zh-tw"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeFormat="HH:mm"
                  timeCaption="Time"
                  selected={this.state.selectStartTime}
                  onChange={this.handleSelectStartTimeChange}
                  minTime={moment(`${moment().format("YYYY-MM-DD")}T06:00`)}
                  maxTime ={moment(`${moment().format("YYYY-MM-DD")}T23:30`)}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                />
                <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('addShift_date_picker_selectStartTime').click();
                    }}
                >
                  {this.state.selectStartTime.format('HH:mm')}
                </button>
              </div>
              <div className="col-6 col-pad-12">
                <label className="u-form__label text-align-right" style={{flex: '0 0 54px'}}>至：</label>
                <DatePicker
                  id="addShift_date_picker_selectEndTime"
                  locale="zh-tw"
                  showTimeSelect
                  showTimeSelectOnly
                  dateFormat="LT"
                  timeFormat="HH:mm"
                  timeCaption="Time"
                  selected={this.state.selectEndTime}
                  onChange={this.handleSelectEndTimeChange}
                  minTime={moment(`${moment().format("YYYY-MM-DD")}T06:00`)}
                  maxTime ={moment(`${moment().format("YYYY-MM-DD")}T23:30`)}
                  className="u-form__input mobile-hide"
                  disabledKeyboardNavigation
                />
                <button
                    className="btn datepickinput desktop--hide"
                    onClick={(e) => {
                      e.preventDefault();
                      document.getElementById('addShift_date_picker_selectEndTime').click();
                    }}
                >
                  {this.state.selectEndTime.format('HH:mm')}
                </button>
              </div> 
            </div>
            <div className="u-btn-group right">
              <button className="btn btn-md save" onClick={this.handleSaveWorkTime}>儲存</button>
              <button className="btn btn-md cancel m-l-16" onClick={
                (e) => {
                  e.preventDefault();
                  toggleOpen();
                }
              }>取消</button>
            </div>
          </form>
        </div>
      </div>
    )
  }
}

export default addEventBlock;